import { useEffect, useState } from 'react'
import { Box } from '@mui/system'
import { useLogin } from '@/hooks/useLoginContext'
import { Avatar, Typography } from '@mui/material'
import styled from 'styled-components'
import Loader from './Loader'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined'
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'

const Icon = styled.div`
  cursor: pointer;
  :hover {
    color: #142954;
  }
`
function DashboardHeader() {
  const [loading, isLoading] = useState(false)
  const { LOGOUT, SET_CUSTOMER_DATA, CUSTOMER_DATA } = useLogin()

  useEffect(() => {
    if (localStorage.getItem('user')) {
      SET_CUSTOMER_DATA(JSON.parse(localStorage.getItem('user')))
    }
  }, [])

  function stringToColor(string: string) {
    let hash = 0
    let i

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash)
    }

    let color = '#'

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff
      color += `00${value.toString(16)}`.slice(-2)
    }
    /* eslint-enable no-bitwise */

    return color
  }

  function stringAvatar(name: string) {
    const fullName = name.split(' ').length > 1
    return {
      sx: {
        bgcolor: stringToColor(name)
      },
      children: fullName
        ? `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
        : `${name.charAt().toUpperCase()}`
    }
  }

  async function disconnectCustomer() {
    try {
      isLoading(true)
      await LOGOUT()
    } finally {
      isLoading(false)
    }
  }

  return (
    <Box
      bgcolor="white"
      height="72px"
      paddingY="20px"
      display="flex"
      alignItems="center"
      width="100%"
      justifyContent="flex-end"
      borderLeft="1px solid #f6f8fd"
      borderBottom="1px solid #f6f8fd"
    >
      <Loader type="page" inLoading={loading} />
      <Box
        display="flex"
        alignItems="center"
        height="48px"
        borderRight="1px solid #f6f8fd"
        marginRight={{ md: '16px' }}
      >
        <Icon>
          <HelpOutlineOutlinedIcon
            style={{ fontSize: '25px', marginRight: '24px' }}
          />
        </Icon>
        <Icon>
          <NotificationsOutlinedIcon
            style={{ fontSize: '25px', marginRight: '24px' }}
          />
        </Icon>
        <Icon onClick={disconnectCustomer}>
          <LogoutOutlinedIcon
            style={{ fontSize: '25px', marginRight: '24px' }}
          />
        </Icon>
      </Box>
      <Box display="flex" alignItems="center">
        <Box
          display={{ xs: 'none', md: 'flex' }}
          flexDirection="column"
          mr="16px"
        >
          <Typography fontSize="18px" color="#2E363E">
            {CUSTOMER_DATA?.nome ?? ''}
          </Typography>
          <Typography fontSize="14px">{CUSTOMER_DATA?.email ?? ''}</Typography>
        </Box>
        <Avatar
          {...stringAvatar(CUSTOMER_DATA?.nome ?? 'Anônimo')}
          style={{ marginRight: '32px' }}
        />
      </Box>
    </Box>
  )
}

export default DashboardHeader
